import React, {useState, useEffect, useCallback} from 'react';
import {    
            AppBar,
            Grid,
            Paper,
            Tab,
            Tabs,
        } from '@material-ui/core';
import { useAuth } from '../Auth';
import RegistrarEquipos from './Registrar';
import ListadoEquipos from './Listado';


function useWindowSize() {
    // Initialize state with undefined width/height so server and client renders match
    // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
    const [windowSize, setWindowSize] = useState({
      width: undefined,
      height: undefined,
    });
    useEffect(() => {
      // Handler to call on window resize
      function handleResize() {
        // Set window width/height to state
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      }
      // Add event listener
      window.addEventListener("resize", handleResize);
      // Call handler right away so state gets updated with initial window size
      handleResize();
      // Remove event listener on cleanup
      return () => window.removeEventListener("resize", handleResize);
    }, []); // Empty array ensures that effect is only run on mount
    return windowSize;
}

const Zonas = (props)=>{
    const size = useWindowSize();
    const { authTokens, setOpen, setRuta } = useAuth(); 
    const [ data, setData ] = useState([]);
    const [ valueTab, setValueTab ] = useState(0);
    const [ Marcas, setMarcas ] = useState([]);
    const [ ModelosList, setModelosList ] = useState([]);
    const [ Empresas, setEmpresas ] = useState([]);

    useEffect(
        ()=>{
            const handleData = async ()=>{
                setRuta('/Conf/Zonas');
                setOpen(false);
                const Peticion = await fetch('api/zonas');
                const result = await Peticion.json();
                if(authTokens.Type === 'ADMINISTRADOR'){
                    setData(result.filter(el=> el.Empresa === authTokens.Empresa));   
                }else{
                    if(result.length > 0){
                        const arrFilZona = result.filter(el=> el.Empresa === authTokens.Empresa).filter(value=> authTokens.Zonas.includes(value.Zona.toString()))
                        setData(arrFilZona);
                    }
                }
                const lMarcas = await fetch('/api/Marcas');
                const lModelos = await fetch('/api/EquiposAls');
                const lEmpresas = await fetch('/api/Empresas');
                const jMarcas = await lMarcas.json();
                const jModelos = await lModelos.json();     
                const jEmpresas = await lEmpresas.json();        
                const arrF = jModelos.filter(el=> el.Empresa === authTokens.Empresa).filter(el=>el.Tipo === 'ROUTERBOARD');
                setMarcas(jMarcas.filter(el=> el.Empresa === authTokens.Empresa));
                setModelosList(arrF);
                setEmpresas(jEmpresas.map(el=>el.Empresa));
            };

            handleData();
        },[] // eslint-disable-line react-hooks/exhaustive-deps
    ); 

    const handleProcess = useCallback((props)=>{
        const arr2 = [...data];
        arr2.push(props);
        setData(arr2);
    },[data]);

    const handleUpdate = useCallback((props)=>{
        const arrBack = [...data];
        const arr2 = arrBack.map(value=>{
            if(value._id === props._id){
                return props
            }else{
                return value
            }
        });
        setData(arr2);
    },[data]);

    const handleDelete = useCallback((props)=>{
        const arrBack = [...data];
        const arr2 = arrBack.filter(value=> value._id !== props._id)
        setData(arr2);
    },[data]);

    const handleChangeTab = (e,value)=>{ setValueTab(value);};

    return(
        <Grid container justifycontent='center' style={{padding:10}}>       
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <Paper style={{width:'99.9%', overflowX:'hidden',height:size.height === undefined ? 0 : size.height - 90}}>

                    <AppBar position="static" style={{position:'sticky', top:0, zIndex:2}}>
                        <Tabs value={valueTab} onChange={handleChangeTab} aria-label="simple tabs example" centered>
                            <Tab label="REGISTRAR" />
                            <Tab label="LISTADO" />
                        </Tabs>
                    </AppBar>
                    
                    <div
                        role="tabpanel"
                        hidden={valueTab !== 0}
                        id={`simple-tabpanel-${0}`}
                        aria-labelledby={`simple-tab-${0}`}
                    >
                    {valueTab === 0 && (
                        <RegistrarEquipos 
                            data={data} 
                            Empresas={Empresas}
                            handleProcess={handleProcess} 
                            handleUpdate={handleUpdate} 
                            Marcas={Marcas} 
                            ModelosList={ModelosList}
                        />
                    )}
                    </div>
                    <div
                        role="tabpanel"
                        hidden={valueTab !== 1}
                        id={`simple-tabpanel-${1}`}
                        aria-labelledby={`simple-tab-${1}`}
                    >
                    {valueTab === 1 && (
                        <ListadoEquipos 
                            data={data} 
                            Empresas={Empresas}
                            handleProcess={handleProcess} 
                            handleUpdate={handleUpdate} 
                            handleDelete={handleDelete} 
                            Marcas={Marcas} 
                            ModelosList={ModelosList}
                        />
                    )}
                    </div>
                </Paper>
            </Grid>
        </Grid>
    )
};

export default Zonas;